import { useParams } from "react-router-dom";
import useWorkbenchBasePath from "rwb/pages/project/hooks/useWorkbenchBasePath";

/**
 * Determines the base path for file operations based on the current route context (global/workbench/dataset)
 *
 * @example
 * Returns file browser prefix paths such as "/workbenches/123/files", "/data-browser/datasets/456/files", or "/data-browser/files"
 */
const useBasePath = () => {
  const { projectId, datasetId, prefixId } = useParams();
  const workbenchBasePath = useWorkbenchBasePath();

  if (projectId) {
    return `${workbenchBasePath}/files`;
  }
  if (datasetId) {
    const root = `/data-browser/datasets/${datasetId}/files`;
    if (prefixId) {
      return `${root}/${prefixId}`;
    }
    return root;
  }

  // Global file browser is now under /data-browser/files
  return "/data-browser/files";
};

export default useBasePath;
